import React, { useEffect, useRef } from "react";
import "@dotlottie/player-component";
import { type DotLottiePlayer } from "@dotlottie/player-component";
import animationData from "Assets/lottie/DedicatedOfficeSpace";

interface HeroAnimationProps {
}

const HeroAnimation: React.FC<HeroAnimationProps> = () => {
   const playerRef = useRef<DotLottiePlayer>(null);

   async function load(player: DotLottiePlayer) {
      player.addEventListener("ready", () => {
         playerRef.current!.style.opacity = "1";
         
         setTimeout(() => {
            const lottie = player.getLottie();
            if (lottie) {
               lottie.setSegment(0, 239);
               player.play();
            }
         }, 1000);
      }, { once: true });

      player.load(animationData, undefined, {
         autoplay: false,
         loop: false
      });
   }

   useEffect(() => {
      const player = playerRef.current;
      player && load(player);
   }, []);

   return <dotlottie-player
      ref={playerRef}
      style={{ opacity: "0", transition: "opacity .5s" }}
   />
}

export default HeroAnimation;